import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesCommissionUnapprovedLinesDataGrid } from "src/components/views/erp/sales/salesCommissions/SalesCommissionUnapprovedLinesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/salesCommissions/unapprovedSalesCommissionLines")({
	staticData: {
		title: i18n.t("unapproved_commission_installments"),
		legacyViewKey: "unapprovedSalesCommissionLinesView",
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesCommissionUnapprovedLinesDataGrid />;
}
